"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperationStatus = void 0;
var OperationStatus;
(function (OperationStatus) {
    OperationStatus["SUCCEEDED"] = "SUCCEEDED";
    OperationStatus["INTERNAL_ERROR"] = "INTERNAL_ERROR";
    OperationStatus["AUTHENTICATION_FAILURE"] = "AUTHENTICATION_FAILURE";
    OperationStatus["AUTHORIZATION_FAILURE"] = "AUTHORIZATION_FAILURE";
    OperationStatus["UNKNOWN_FAILURE"] = "UNKNOWN_FAILURE";
    OperationStatus["INVALID_STORE_STATE"] = "INVALID_STORE_STATE";
    OperationStatus["INVALID_STORE_CONFIGURATION"] = "INVALID_STORE_CONFIGURATION";
    OperationStatus["OPERATION_NOT_SUPPORTED"] = "OPERATION_NOT_SUPPORTED";
    OperationStatus["IGNORED_ALREADY_IN_REQUESTED_STATE"] = "IGNORED_ALREADY_IN_REQUESTED_STATE";
    OperationStatus["INVALID_REQUEST"] = "INVALID_REQUEST";
})(OperationStatus = exports.OperationStatus || (exports.OperationStatus = {}));
